import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Box,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
} from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useFormik } from "formik";
import moment from "moment";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import { createGlobalOffersThunk } from "store/reducers/global_offers/globalOffersSlice";
import { getMinMachinesThunk } from "store/reducers/vending";
import * as yup from "yup";

const validation = yup.object({
  offer_name: yup.string().required("Name required"),
  offer_code: yup.string(),
  offer_announcement: yup.string(),
  offer_percentage: yup.number().required(),
  occasion: yup.string().required(),
  min_purchase_price: yup.number().required(),
  override_product_offers: yup.boolean().required(),
  // priority_level: yup.number().required(),
  offer_scope: yup.string(),
  offer_from_date: yup.string(),
  offer_to_date: yup.string(),
});

const GlobalOfferCreate = () => {
  const { status } = useSelector((state) => state.globalOffers);
  const formik = useFormik({
    initialValues: {
      offer_name: "",
      offer_code: "",
      offer_announcement: "",
      offer_announcement_image:"",
      offer_percentage: 5.0,
      min_purchase_price: 0.0,
      occasion: "fst",
      override_product_offers: true,
      // priority_level: 1,
      offer_scope: "all",
      associated_machine: [],
      offer_from_date: moment().format("YYYY-MM-DD"),
      offer_to_date: moment().add(7, "days").format("YYYY-MM-DD"),
    },
    validationSchema: validation,

    onSubmit: (data) => {
      const _data = { ...data };
      Object.keys(_data).forEach((key) => {
        if (_data[key] === "") {
          _data[key] = null;
        }
      });

      if (_data.offer_scope === "all") {
        _data.associated_machine = [];
      }
      console.log(_data);
      dispatch(createGlobalOffersThunk(_data));
    },
    validateOnChange: false,
  });

  useEffect(() => {
    dispatch(getMinMachinesThunk());
  }, []);

  const machines = useSelector((state) => state.vending.minMachines);

  useEffect(() => {
    if (status?.error === "create") {
      // console.log(status?.errorMessage);
      Object.keys(status?.errorMessage).forEach((key) => {
        // console.log(key, status?.errorMessage[key][0]);
        formik.setFieldError(key, status?.errorMessage[key][0]);
      });
    }
  }, [status]);

  return (
    <Box marginTop={2}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1.5} paddingY={1}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Offer name"
              variant="outlined"
              name="offer_name"
              fullWidth
              value={formik.values.offer_name}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.offer_name)}
              helperText={formik.errors.offer_name}
              autoComplete="new-password"
              type="text"
              required
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Offer code"
              variant="outlined"
              name="offer_code"
              fullWidth
              value={formik.values.offer_code}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.offer_code)}
              helperText={formik.errors.offer_code}
              autoComplete="new-password"
              type="text"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Offer announcement"
              variant="outlined"
              name="offer_announcement"
              fullWidth
              value={formik.values.offer_announcement}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.offer_announcement)}
              helperText={formik.errors.offer_announcement}
              autoComplete="new-password"
              type="text"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Offer announcement image"
              variant="outlined"
              name="offer_announcement_image"
              fullWidth
              // value={formik.values.offer_announcement_image}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.offer_announcement_image)}
              helperText={formik.errors.offer_announcement_image}
              autoComplete="off"
              type="file"
              InputLabelProps={{ shrink: true }}
              InputProps={{
                inputProps: { accept: 'image/*' },
                onChange: (event)=>{
                  formik.setFieldValue('offer_announcement_image', event.currentTarget.files[0]);
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Offer percentage"
              variant="outlined"
              name="offer_percentage"
              fullWidth
              value={formik.values.offer_percentage}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.offer_percentage)}
              helperText={formik.errors.offer_percentage}
              autoComplete="new-password"
              type="number"
              required
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">%</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Min purchase price"
              variant="outlined"
              name="min_purchase_price"
              fullWidth
              value={formik.values.min_purchase_price}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.min_purchase_price)}
              helperText={formik.errors.min_purchase_price}
              autoComplete="new-password"
              type="number"
              required
            />
          </Grid>
          {/* <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Priority level"
              variant="outlined"
              name="priority_level"
              fullWidth
              value={formik.values.priority_level}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.priority_level)}
              helperText={formik.errors.priority_level}
              autoComplete="new-password"
              type="number"
              required
            />
          </Grid> */}
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Occasion"
              variant="outlined"
              name="occasion"
              select
              fullWidth
              value={formik.values.occasion}
              onChange={formik.handleChange("occasion")}
              error={Boolean(formik.errors.occasion)}
              helperText={formik.errors.occasion}
              autoComplete="new-password"
              required
            >
              <MenuItem value={"fst"}>Festival</MenuItem>
              <MenuItem value={"new"}>New registration</MenuItem>
              <MenuItem value={"reg"}>Registered users</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Override product offers"
              variant="outlined"
              name="override_product_offers"
              select
              fullWidth
              value={formik.values.override_product_offers}
              onChange={formik.handleChange("override_product_offers")}
              error={Boolean(formik.errors.override_product_offers)}
              helperText={formik.errors.override_product_offers}
              autoComplete="new-password"
              required
            >
              <MenuItem value={true}>Yes</MenuItem>
              <MenuItem value={false}>No</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Offer scope"
              variant="outlined"
              name="offer_scope"
              select
              fullWidth
              value={formik.values.offer_scope}
              onChange={formik.handleChange("offer_scope")}
              error={Boolean(formik.errors.offer_scope)}
              helperText={formik.errors.offer_scope}
              autoComplete="new-password"
              required
            >
              <MenuItem value="all">All machines</MenuItem>
              <MenuItem value="sel">Selected machines</MenuItem>
            </TextField>
          </Grid>
          {formik.values.offer_scope === "sel" && (
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="Select machines"
                variant="outlined"
                name="associated_machine"
                select
                SelectProps={{
                  multiple: true,
                  value: formik.values.associated_machine,
                  onChange: formik.handleChange("associated_machine"),
                }}
                fullWidth
                error={Boolean(formik.errors.associated_machine)}
                helperText={formik.errors.associated_machine}
                autoComplete="new-password"
                required
              >
                {machines.map((machine) => (
                  <MenuItem key={machine.id} value={machine.id}>
                    {machine.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )}
          <Grid item xs={12} md={6} lg={4}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                label="Offer from date"
                inputFormat="YYYY-MM-DD"
                name="offer_from_date"
                value={formik.values.offer_from_date}
                onChange={(value) =>
                  formik.setFieldValue(
                    "offer_from_date",
                    value.format("YYYY-MM-DD"),
                    true
                  )
                }
                renderInput={(params) => (
                  <TextField fullWidth variant="outlined" {...params} />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                label="Offer to date"
                inputFormat="YYYY-MM-DD"
                name="offer_to_date"
                value={formik.values.offer_to_date}
                onChange={(value) =>
                  formik.setFieldValue(
                    "offer_to_date",
                    value.format("YYYY-MM-DD"),
                    true
                  )
                }
                renderInput={(params) => (
                  <TextField fullWidth variant="outlined" {...params} />
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
        {status?.error === "create" && (
          <Alert sx={{ my: 1 }} severity="error">
            Error occurred
          </Alert>
        )}

        {status?.success === "create" && (
          <Alert sx={{ my: 1 }} severity="success">
            Success
          </Alert>
        )}

        <LoadingButton
          variant="contained"
          type="submit"
          sx={{ paddingX: 10, marginTop: 1 }}
          loading={status?.loading === "create"}
        >
          Add
        </LoadingButton>
      </form>
    </Box>
  );
};

export default GlobalOfferCreate;
